import React from 'react'
import { newBtnStyle, typoStyle, averageStyle } from "../styles/globalStyle"
import Typography from '@mui/material/Typography';
import { Box, TextField } from '@mui/material';
import DokumHattiModal from '../components/modals/DokumHattiModal';
import { useSelector } from 'react-redux';
import useArge from '../hooks/useArge';
import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import DeleteModals from '../components/deleteModals/DeleteModals';
import DokumHatti_DataTable from '../components/tables/DokumHatti_DataTable';
import { HiOutlineSearch } from "react-icons/hi";
import { toastWarnNotify } from '../helpers/ToastNotify';
import { dataAverage } from '../helpers/Calculate';

const Dokumhatti = () => {

  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [dokumHatti, setdokumHatti] = useState([])

  const [delOpen, setdelOpen] = React.useState(false);
  const delHandleOpen = () => setdelOpen(true);
  const delHandleClose = () => setdelOpen(false);

  const { getMaterialCenter, getWorkCenter, getFireData } = useArge()
  const { workCenterCode, materialCode, dokumHattiData, loading } = useSelector((state) => state.arge)

  let getVardiya = 0;

  const { currentUser } = useSelector((state) => state.auth)


  const [averages, setAverages] = useState({
    kurutmaSicakligi: 0,
    taban: 0,
    camurSicakligi: 0,
    t1t2: 0,
    yogunluk: 0,
    t1: 0,
    t2: 0,
  });

  const [infoDate, setInfoDate] = useState({
    dateFrom: "",
    dateTo: ""
  })

  const getShift = () => {
    //! padStart(2,'0') metodu ile hedefUzunluk ve eklenecek karakterler olarak iki parametre alır.
    const hour = new Date().getHours().toString().padStart(2, '0')

    if (hour > 8 && hour < 16) {
      getVardiya = 2
    }
    else if (hour > 16 && hour < 23) {
      getVardiya = 3
    }
    else {
      getVardiya = 1
    }

    return getVardiya

  }

  const [info, setInfo] = useState({
    department: "Sekillendirme",
    type: "DokumHatti",
    is_merkezi: "",
    aciklama: "",
    urun_kodu: "",
    kurutmaSicakligi: "",
    camurSicakligi: "",
    yogunluk: "",
    t1: "0",
    t2: "0",
    t1t2: "0",
    ucDakika: "",
    besDakika: "",
    onDakika: "",
    agirlik: "",
    taban: "",
    ab: "",
    cd: "",
    cidarKalinlik: "",
    catlak: "",
    rotus: "",
    yuzeyKontrol: "",
    uygunsuzlukTipi: "",
    vardiyaSorumlusu: "",
    oldData_date: "",
    vardiya: getShift(),
    date: "",
    time: "",
    kontroleden_kisi: currentUser,
    newMaterialName: ""
  })

  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false)
    setInfo({
      type: "DokumHatti",
      is_merkezi: "",
      aciklama: "",
      urun_kodu: "",
      kurutmaSicakligi: "",
      camurSicakligi: "",
      yogunluk: "",
      t1: "0",
      t2: "0",
      t1t2: "0",
      ucDakika: "",
      besDakika: "",
      onDakika: "",
      agirlik: "",
      taban: "",
      ab: "",
      cd: "",
      cidarKalinlik: "",
      catlak: "",
      rotus: "",
      yuzeyKontrol: "",
      uygunsuzlukTipi: "",
      vardiyaSorumlusu: "",
      oldData_date: "",
      vardiya: getShift(),
      date: "",
      time: "",
      kontroleden_kisi: currentUser,
      newMaterialName: ""
    })
  }


  useEffect(() => {

    getMaterialCenter()
    getWorkCenter()

    getFireData("DokumHatti")

  }, [])


  // istatistik datasındaki ortalama hesaplamasını yapar
  useEffect(() => {

    const dizi = Object.keys(dokumHattiData).map(key => { return { id: key, ...dokumHattiData[key] } });

    dizi.sort((a, b) => {
      const convertDateTime = (date, time) => {
        if (!date || !time) {
          return new Date(0); // 1 Ocak 1970
        }
        const [day, month, year] = date.split('-').map(num => num.padStart(2, '0'));
        const [hours, minutes] = time.split(':').map(num => num.padStart(2, '0'));
        return new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
      };

      const dateTimeA = convertDateTime(a.date, a.time);
      const dateTimeB = convertDateTime(b.date, b.time);

      return dateTimeB - dateTimeA;
    });

    // Ortalama hesaplamaları
    const total = {
      kurutmaSicakligi: 0,
      taban: 0,
      camurSicakligi: 0,
      t1t2: 0,
      yogunluk: 0,
      t1: 0,
      t2: 0,
    };

    const count = dizi.length;

    dizi.forEach(item => {
      total.kurutmaSicakligi += parseFloat(item.kurutmaSicakligi) || 0;
      total.taban += parseFloat(item.taban) || 0;
      total.t1t2 += parseFloat(item.t1t2) || 0;
      total.t1 += parseFloat(item.t1) || 0;
      total.t2 += parseFloat(item.t2) || 0;
      total.yogunluk += parseFloat(item.yogunluk) || 0;
      total.camurSicakligi += parseFloat(item.camurSicakligi) || 0;
    });

    const averages = {
      kurutmaSicakligi: (total.kurutmaSicakligi / count).toFixed(2),
      taban: (total.taban / count).toFixed(2),
      t1t2: (total.t1t2 / count).toFixed(2),
      t1: (total.t1 / count).toFixed(2),
      t2: (total.t2 / count).toFixed(2),
      yogunluk: (total.yogunluk / count).toFixed(2),
      camurSicakligi: (total.camurSicakligi / count).toFixed(2),
    };

    // Ortalamaları state'e kaydediyoruz
    setAverages(averages); 

  }, [dokumHattiData]);



  const handleChangeDate = (e) => {
    const { name, value } = e.target
    setInfoDate({ ...infoDate, [name]: value })
  }



  const handleDateFilter = () => {

    if (infoDate.dateFrom && infoDate.dateTo) {

      //! tarih filtreleme işleminde son seçilen sarih bilgisi localStorage taragında saklanır.
      // localStorage.setItem('lastSelectedDate', JSON.stringify(info))

      getFireData('DokumHatti', infoDate.dateFrom, infoDate.dateTo)

    }
    else {
      toastWarnNotify('Tarih bilgisini kontrol ediniz !')
    }

  }



  return (

    <div>
      <Typography mt={8} align='center' variant='h5' fontWeight={700} sx={typoStyle}>
        Döküm Hattı
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

        <Box>
          <Button onClick={handleOpen} variant='outlined' sx={newBtnStyle}>New</Button>
        </Box>


        <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 1, alignItems: 'center', p: 2 }}>
          <Typography>From</Typography>
          <TextField
            required
            id='dateFrom'
            name='dateFrom'
            type='date'
            value={infoDate.dateFrom}
            onChange={handleChangeDate}
          />

          <Typography>To</Typography>
          <TextField
            required
            id='dateTo'
            name='dateTo'
            type='date'
            value={infoDate.dateTo}
            onChange={handleChangeDate}
          />
          <HiOutlineSearch size={30} color='black' onClick={handleDateFilter} cursor={'pointer'} style={{ marginLeft: 15 }} />
        </Box>

      </Box>

      <DokumHattiModal open={open} handleClose={handleClose} info={info} setInfo={setInfo} workCenterCode={workCenterCode} materialCode={materialCode} />

      <DeleteModals delOpen={delOpen} delHandleClose={delHandleClose} delHandleOpen={delHandleOpen} setdelOpen={setdelOpen} info={info} />



      <Box>
        {
          loading ?
            (
              <Typography>Loading..</Typography>
            )
            :
            (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>

                  <Typography style={averageStyle}>Çamur Sıcaklığı : {averages.camurSicakligi}</Typography>
                  <Typography style={averageStyle}>Kurutma Sıcaklığı : {averages.kurutmaSicakligi}</Typography>
                  <Typography style={averageStyle}>T1 : {averages.t1}</Typography>
                  <Typography style={averageStyle}>T2 : {averages.t2}</Typography>
                  <Typography style={averageStyle}>T1-T2 : {averages.t1t2}</Typography>
                  <Typography style={averageStyle}>Taban : {averages.taban}</Typography>
                  <Typography style={averageStyle}>Yoğunluk : {averages.yogunluk}</Typography>

                </Box>

                <DokumHatti_DataTable
                  handleOpen={handleOpen}
                  delHandleOpen={delHandleOpen}
                  setInfo={setInfo}
                  info={info}
                  dokumHattiData={dokumHattiData}
                  filterModel={filterModel}
                  setFilterModel={setFilterModel}
                  dokumHatti={dokumHatti}
                  setdokumHatti={setdokumHatti}
                />
              </Box>
            )
        }
      </Box>

    </div>


  )
}

export default Dokumhatti